export const errors = {
  'Orden no existente.':
    'No se ha encontrado la orden en el sistema, favor de corroborar el ID de la orden',
  default: 'Error desconocido, vuelva a intentar más tarde',
};
